import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ApiService } from '@services';

/**
 * Wisper users service.
 *
 * @author Ihar Kazlouski
 * @class WisperUsersServiceClass
 * @category Services
 */
var WisperUsersServiceClass = /*#__PURE__*/function () {
  function WisperUsersServiceClass() {
    _classCallCheck(this, WisperUsersServiceClass);
  }

  _createClass(WisperUsersServiceClass, [{
    key: "apiWisperUsersGet",
    value:
    /**
     * Wisper users get api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<WiperUsersResponseType>>} accounts list promise.
     */
    function () {
      var _apiWisperUsersGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", ApiService.apiGet('/wisper-users', _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function apiWisperUsersGet(_x) {
        return _apiWisperUsersGet.apply(this, arguments);
      }

      return apiWisperUsersGet;
    }()
    /**
     * Wisper users filter post api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<WiperUsersResponseType>>} wisper users list promise.
     */

  }, {
    key: "apiSearchWisperUsersPost",
    value: function () {
      var _apiSearchWisperUsersPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", ApiService.apiPost('/search-wisper-users', _objectSpread({}, params.body), _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function apiSearchWisperUsersPost(_x2) {
        return _apiSearchWisperUsersPost.apply(this, arguments);
      }

      return apiSearchWisperUsersPost;
    }()
  }]);

  return WisperUsersServiceClass;
}();

var WisperUsersService = new WisperUsersServiceClass();
export { WisperUsersService };